export default __webpack_public_path__ + "static/media/mountain.d13fad73.svg";